<template>
  <v-row justify="center">
    <v-dialog v-model="orderdetailmodal" max-width="1000">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="orderdetailmodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <strong>{{ title }}&nbsp;</strong>
            {{ orderdatas.order_no }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br />

        <!-- View Detail mode -->
        <div v-if="!isedit">
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เลขที่เอกสาร : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdatas.order_no }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>รหัสร้านค้า : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdatas.username }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เจ้าหน้าที่ผู้ดูแล : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdatas.adminref_name }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>ชื่อ-สกุล : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdatas.name }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>ที่อยู่จัดส่ง : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdatas.address }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เบอร์โทร : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ orderdatas.tel }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>วันที่สั่งซื้อ : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ order_date_th }}</p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>สถานะ : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-chip
                  :color="getColor(orderdatas.order_status)"
                  text-color="white"
                  >{{ orderdatas.order_status_th }}</v-chip
                >
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>การชำระเงิน : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-chip :color="getColor(orderdatas.payment_status)" outlined>{{
                  orderdatas.payment_status_th
                }}</v-chip>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center v-if="delivery_date_th">
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>วันที่จัดส่ง : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <p>{{ delivery_date_th }}</p>
              </div>
            </v-flex>
          </v-layout>
        </div>

        <!-- Edit mode -->
        <div v-if="isedit">
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เลขที่เอกสาร : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-text-field
                  v-model="orderdatas.order_no"
                  solo
                  dense
                  readonly
                  background-color="grey lighten-2"
                  color="pink lighten-2"
                  style="display: inline"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>รหัสร้านค้า : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-text-field
                  v-model="orderdatas.username"
                  solo
                  dense
                  readonly
                  background-color="grey lighten-2"
                  color="pink lighten-2"
                  style="display: inline"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>ชื่อ-สกุล : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-text-field
                  ref="customername"
                  v-model="name"
                  solo
                  dense
                  color="pink lighten-2"
                  style="display: inline"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>ที่อยู่จัดส่ง : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-text-field
                  v-model="address"
                  solo
                  dense
                  color="pink lighten-2"
                  style="display: inline"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>เบอร์โทร : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-text-field
                  v-model="tel"
                  solo
                  dense
                  color="pink lighten-2"
                  style="display: inline"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>วันที่สั่งซื้อ : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-text-field
                  v-model="order_date_th"
                  solo
                  dense
                  readonly
                  background-color="grey lighten-2"
                  color="pink lighten-2"
                  style="display: inline"
                ></v-text-field>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>สถานะ : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-select
                  :items="orderstatusitems"
                  solo
                  item-text="text"
                  item-value="value"
                  v-model="order_status_change"
                  color="pink lighten-2"
                  v-on:input="changeorderstatus(order_status_change)"
                ></v-select>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>การชำระเงิน : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-select
                  :items="paymentstatusitems"
                  solo
                  item-text="text"
                  item-value="value"
                  color="pink lighten-2"
                  v-model="payment_status_change"
                ></v-select>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>วันที่จัดส่ง : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div>
                <v-dialog
                  ref="dialog1"
                  v-model="delivery_modal"
                  :return-value.sync="delivery_date"
                  width="350px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="delivery_date"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      color="pink lighten-2"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    persistent
                    v-model="delivery_date"
                    scrollable
                    color="pink lighten-2"
                    width="350px"
                    locale="th-TH"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="pink lighten-2"
                      @click="delivery_modal = false"
                      >ยกเลิก</v-btn
                    >
                    <v-btn
                      text
                      color="pink"
                      @click="$refs.dialog1.save(delivery_date)"
                      >ตกลง</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-flex>
          </v-layout>
          <v-layout align-center v-if="isdelivery">
            <v-flex xs12 sm3 md3 lg3>
              <div class="ml-10">
                <p align="right">
                  <strong>วันที่จัดส่ง : &nbsp;</strong>
                </p>
              </div>
            </v-flex>
            <v-flex xs12 sm5 md5 lg5>
              <div>
                <v-dialog
                  ref="dialog1"
                  v-model="delivery_modal"
                  :return-value.sync="delivery_date"
                  width="350px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="delivery_date"
                      prepend-inner-icon="mdi-calendar"
                      outlined
                      dense
                      color="pink lighten-2"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    persistent
                    v-model="delivery_date"
                    scrollable
                    color="pink lighten-2"
                    width="350px"
                    locale="th-TH"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="pink lighten-2"
                      @click="delivery_modal = false"
                      >ยกเลิก</v-btn
                    >
                    <v-btn
                      text
                      color="pink"
                      @click="$refs.dialog1.save(delivery_date)"
                      >ตกลง</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <br />
        <div class="ml-10">
          <p align="center">
            <strong>รายการสินค้า</strong>
          </p>
        </div>
        <v-container>
          <v-layout justify-center>
            <v-flex xs10 sm10 md10 lg10>
              <v-data-table
                :headers="headers"
                :items="productitems"
                hide-default-footer
                class="elevation-2"
                item-key="_id"
                disable-pagination
              >
                <template v-slot:item.image="{ item }">
                  <v-container v-if="item.image">
                    <v-img
                      class="white--text align-center"
                      style="height: 60px; width: 90px"
                      :src="item.image"
                    ></v-img>
                  </v-container>
                </template>
                <template v-slot:body.append>
                  <br />
                  <tr>
                    <td colspan="4"></td>
                    <td>
                      <div>
                        <p align="right">
                          <strong>สินค้ารวม</strong>
                        </p>
                        <p align="right">
                          <strong>รวม</strong>
                          <small style="color: black">(ราคาไม่รวมภาษี)</small>
                        </p>
                      </div>
                    </td>
                    <td>
                      <v-layout>
                        <v-flex xs12 sm12 md7 lg7>
                          <p class="mr-2" align="right">{{ productamount }}</p>
                        </v-flex>
                        <v-flex xs12 sm12 md5 lg5>
                          <span class="ml-1">ชิ้น</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs12 sm12 md7 lg7>
                          <p class="mr-2" align="right" style="color: red">
                            {{ amount }}
                          </p>
                        </v-flex>
                        <v-flex xs12 sm12 md5 lg5>
                          <span class="ml-1" style="color: red">บาท</span>
                        </v-flex>
                      </v-layout>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
        <br />
        <v-layout justify-center v-if="paymentconfirm_image !== ''">
          <div class="ml-10">
            <p align="center">
              <strong>รายละเอียดการชำระเงิน</strong>
            </p>
          </div>
        </v-layout>
        <v-layout justify-center v-if="paymentconfirm_image !== ''">
          <div>
            <expandable-image
              class="ml-10 image"
              :src="paymentconfirm_image"
              :close-on-background-click="true"
            />
          </div>
        </v-layout>
        <v-layout
          justify-center
          v-if="
            orderdatas.payment_related &&
            orderdatas.payment_related.length !== 0
          "
        >
          <p>
            <small style="color: black"
              >การชำระเงินที่เกี่ยวข้อง: &nbsp;{{
                orderdatas.payment_related.toString().replace(/,/g, ", ")
              }}</small
            >
          </p>
        </v-layout>
        <br />
        <!-- Delivery mode -->
        <v-card-actions v-if="orderdetailmode === 4">
          <div class="flex-grow-1"></div>
          <div>
            <v-btn
              color="pink"
              style="margin-right: 5px"
              outlined
              @click="close()"
              >ยกเลิก</v-btn
            >
            <v-btn
              color="pink lighten-2"
              dark
              @click="delivered(currentorderid)"
              >จัดส่ง</v-btn
            >
          </div>
        </v-card-actions>
        <!-- View detail mode -->
        <v-card-actions v-if="orderdetailmode === 1">
          <div class="flex-grow-1"></div>
          <div v-if="isedit">
            <v-btn
              color="pink"
              style="margin-right: 5px"
              outlined
              @click="cancel()"
              >ยกเลิก</v-btn
            >
            <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
          </div>
          <div v-if="!isedit">
            <v-btn
              color="pink"
              style="margin-right: 5px"
              outlined
              @click="close()"
              >กลับ</v-btn
            >
            <!-- <v-btn v-if="issupadmin" color="pink lighten-2" dark @click="editmode()">Edit</v-btn> -->
          </div>
        </v-card-actions>
        <!-- Approve order mode -->
        <v-layout align-center v-if="orderdetailmode === 2">
          <v-flex xs12 sm3 md3 lg3>
            <div class="ml-10">
              <p align="right">
                <strong>วันที่จัดส่ง : &nbsp;</strong>
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm5 md5 lg5>
            <div>
              <v-dialog
                ref="dialog1"
                v-model="delivery_modal"
                :return-value.sync="delivery_date"
                width="350px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    ref="delidate"
                    v-model="delivery_date"
                    prepend-inner-icon="mdi-calendar"
                    outlined
                    dense
                    color="pink lighten-2"
                    v-on="on"
                    :rules="[(v) => !!v || 'กรุณาเลือกวันที่จัดส่ง']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  persistent
                  v-model="delivery_date"
                  scrollable
                  color="pink lighten-2"
                  width="350px"
                  locale="th-TH"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="pink lighten-2"
                    @click="delivery_modal = false"
                    >ยกเลิก</v-btn
                  >
                  <v-btn
                    text
                    color="pink"
                    @click="$refs.dialog1.save(delivery_date)"
                    >ตกลง</v-btn
                  >
                </v-date-picker>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
        <v-card-actions v-if="orderdetailmode === 2">
          <div class="flex-grow-1"></div>
          <v-btn
            color="pink"
            style="margin-right: 5px"
            outlined
            @click="clicktoedit(orderdatas._id)"
            >แก้ไข</v-btn
          >
          <v-btn
            color="pink"
            style="margin-right: 5px"
            outlined
            @click="saveapprove(0)"
            >ไม่อนุมัติ</v-btn
          >
          <v-btn color="pink lighten-2" dark @click="saveapprove(1)"
            >อนุมัติ</v-btn
          >
        </v-card-actions>
        <!-- Approve confirmpayment mode -->
        <v-card-actions v-if="orderdetailmode === 3">
          <div class="flex-grow-1"></div>
          <v-btn
            color="pink"
            style="margin-right: 5px"
            outlined
            @click="saveapprovepayment(0)"
            >ไม่อนุมัติการชำระเงิน</v-btn
          >
          <v-btn color="pink lighten-2" dark @click="saveapprovepayment(1)"
            >อนุมัติการชำระเงิน</v-btn
          >
        </v-card-actions>
        <br />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ExpandableImage from "./ExpandableImage";
import { sync } from "vuex-pathify";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import numeral from "numeral";
moment.locale("th");
export default {
  components: {
    ExpandableImage,
  },
  data() {
    return {
      issupadmin: false,
      title: "รายการสั่งซื้อ",
      headers: [
        {
          text: "รหัสซื้อขาย",
          align: "center",
          sortable: false,
          value: "product_no",
        },
        { text: "รูปสินค้า", align: "center", sortable: false, value: "image" },
        { text: "ชื่อสินค้า", align: "center", sortable: false, value: "name" },
        { text: "ราคา", align: "center", sortable: false, value: "price" },
        { text: "จำนวน", align: "center", sortable: false, value: "quantity" },
        { text: "ประเภท", align: "center", sortable: false, value: "type" },
      ],
      orderdatas: "",
      productitems: [],
      name: "",
      address: "",
      tel: "",
      order_status: "",
      order_date_th: "",
      delivery_date_th: "",
      delivered_date_th: "",
      amount: 0,
      productamount: 0,
      paymentconfirm_image: "",
      isedit: false,
      order_status_change: [],
      orderstatusitems: [
        { text: "รอการอนุมัติ", value: "00" },
        { text: "อนุมัติ", value: "01" },
        { text: "ไม่อนุมัติ", value: "02" },
        { text: "เตรียมจัดส่ง", value: "10" },
        { text: "จัดส่งสำเร็จ", value: "12" },
      ],
      delivery_modal: false,
      delivery_date: "",
      delivered_modal: false,
      delivered_date: "",
      isdelivery: false,
      isdelivered: false,
      paymentstatusitems: [
        { text: "รอการชำระเงิน", value: "0" },
        { text: "ชำระแล้วรอการอนุมัติ", value: "1" },
        { text: "อนุมัติ", value: "2" },
        { text: "ไม่อนุมัติ", value: "3" },
        { text: "ไม่ต้องชำระ", value: "4" },
      ],
      payment_status_change: [],
    };
  },
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    parentgetdata: "",
  },
  methods: {
    getColor(status) {
      if (status === "00") return "info";
      else if (status === "01") return "success";
      else if (status === "02") return "#DD4B39";
      else if (status === "10") return "#52B9EB";
      else if (status === "11") return "#F7BA38";
      else if (status === "12") return "#388E3C";
      else if (status === "13") return "#F23B22";
      else if (status === "0") return "info";
      else if (status === "1") return "warning";
      else if (status === "2") return "success";
      else if (status === "3") return "#DD4B39";
      else if (status === "4") return "#000000";
    },
    async saveapprovepayment(mode) {
      try {
        if (mode) {
          this.$router.push(`/download/${this.currentorderid}`);
        } else {
          await swal({
            title: `ไม่อนุมัติการชำระเงินของรายการสั่งสินค้านี้ ?`,
            icon: "warning",
            buttons: ["ยกเลิก", "ไม่อนุมัติ"],
            dangerMode: true,
          }).then(async (isconfirm) => {
            if (isconfirm) {
              this.$router.push(`/download/${this.currentorderid}`);
            }
          });
        }
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: "กรุณาลองอีกครั้งในภายหลัง",
          icon: "warning",
          buttons: "ตกลง",
          dangerMode: true,
        });
      }
    },
    async saveapprove(mode) {
      try {
        if (mode === 1 && this.delivery_date === "") {
          await swal({
            title: `กรุณากรอกวันที่จัดส่ง`,
            icon: "warning",
            dangerMode: true,
            buttons: "ตกลง",
          }).then(async (accept) => {
            if (accept) {
              this.$refs.delidate.focus();
            }
          });
        } else {
          if (mode) {
            this.approve(mode);
          } else {
            await swal({
              title: `ไม่อนุมัติรายการสั่งซื้อ เลขที่: ${this.orderdatas.order_no} ใช่หรือไม่ ?`,
              icon: "warning",
              buttons: ["ยกเลิก", "ไม่อนุมัติ"],
              dangerMode: true,
            }).then(async (canceled) => {
              if (canceled) {
                this.approve(mode);
              }
            });
          }
        }
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: "กรุณาลองอีกครั้งในภายหลัง",
          icon: "warning",
          buttons: "ตกลง",
          dangerMode: true,
        });
      }
    },
    async approve(mode) {
      await axios.put(
        `${process.env.VUE_APP_API}/order/edit/approve/${this.currentorderid}`,
        {
          approve_status: Boolean(mode),
          delivery_date: this.delivery_date,
        },
        {
          headers: {
            Authorization: this.$cookies.get("token"),
          },
        }
      );
      this.orderdetailmodal = false;
      const swaltext = mode
        ? `อนุมัติรายการสั่งซื้อ เลขที่: ${this.orderdatas.order_no} เรียบร้อย`
        : `ไม่อนุมัติรายการสั่งซื้อ เลขที่: ${this.orderdatas.order_no} เรียบร้อย`;
      await swal(swaltext, {
        icon: "success",
        buttons: "ตกลง",
      });
      this.parentgetdata();
    },
    async save() {
      try {
        await axios.put(
          `${process.env.VUE_APP_API}/order/edit/${this.currentorderid}`,
          {
            name: this.name,
            address: this.address,
            tel: this.tel,
            order_status:
              this.order_status_change.value || this.order_status_change,
            payment_status:
              this.payment_status_change.value || this.payment_status_change,
            delivery_date: this.delivery_date,
            delivered_date: this.delivered_date,
          },
          {
            headers: {
              Authorization: this.$cookies.get("token"),
            },
          }
        );
        this.isedit = false;
        this.orderdetailmodal = false;
        this.parentgetdata();
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: "กรุณาลองอีกครั้งในภายหลัง",
          icon: "warning",
          buttons: "ตกลง",
          dangerMode: true,
        });
      }
    },
    async getorderdata() {
      try {
        if (this.currentorderid) {
          let { data } = await axios.get(
            `${process.env.VUE_APP_API}/order/get/${this.currentorderid}`,
            {
              headers: {
                Authorization: this.$cookies.get("token"),
              },
            }
          );
          if (data) {
            for (const key in data) {
              this[key] = data[key];
            }
            this.orderdatas = data;
            this.order_status_change = {
              text: data.order_status_th,
              value: data.order_status,
            };
            this.payment_status_change = {
              text: data.payment_status_th,
              value: data.payment_status,
            };
            this.isdelivery =
              data.order_status === "10"
                ? true
                : data.order_status === "11"
                ? true
                : data.order_status === "12"
                ? true
                : data.order_status === "13" || false;
            this.isdelivered =
              data.order_status === "12"
                ? true
                : data.order_status === "13" || false;
            this.delivery_date = data.delivery_date
              ? data.delivery_date.split("T")[0]
              : "";
            this.delivered_date = data.delivered_date
              ? data.delivered_date.split("T")[0]
              : "";
            this.order_date_th = moment(data.order_date).format("LL");
            this.delivery_date_th = data.delivery_date
              ? moment(data.delivery_date).format("LL")
              : "";
            this.delivered_date_th = data.delivered_date
              ? moment(data.delivered_date).format("LL")
              : "";
            this.paymentconfirm_image = data.paymentconfirm_image
              ? `${process.env.VUE_APP_API}${data.paymentconfirm_image}`
              : "";
            this.productitems = data.productitems
              ? data.productitems.map((pd) => {
                  pd.image = pd.image
                    ? `${process.env.VUE_APP_API}${pd.image}`
                    : "";
                  pd.price = numeral(pd.price).format("0,0.00");
                  return { ...pd };
                })
              : [];
            this.amount = numeral(
              data.productitems
                ? data.productitems.reduce((sum, product) => {
                    return (
                      sum + Number(product.price) * Number(product.quantity)
                    );
                  }, 0)
                : 0
            ).format("0,0.00");
            this.productamount = data.productitems
              ? data.productitems.reduce((sum, product) => {
                  return sum + Number(product.quantity);
                }, 0)
              : 0;
          }
        }
      } catch (error) {}
    },
    close() {
      this.isedit = false;
      this.orderdetailmodal = false;
      this.orderdetailmode = 0;
    },
    cancel() {
      this.isedit = false;
    },
    editmode() {
      this.isedit = true;
    },
    changeorderstatus(status) {
      this.isdelivery =
        status === "10"
          ? true
          : status === "11"
          ? true
          : status === "12"
          ? true
          : status === "13" || false;
      this.isdelivered = status === "12" ? true : status === "13" || false;
    },
    async delivered(id) {
      try {
        let deliveredlist = [this.orderdatas];
        await swal({
          title: `ยืนยันการจัดส่งรายการสั่งซื้อ เลขที่: ${deliveredlist[0].order_no} ?`,
          icon: "warning",
          buttons: ["ยกเลิก", "ยืนยัน"],
          dangerMode: true,
        }).then(async (willdelivery) => {
          if (willdelivery) {
            await axios.post(
              `${process.env.VUE_APP_API}/order/edit/delivered`,
              {
                deliveredlist: deliveredlist,
                delivered_status: true,
              },
              {
                headers: {
                  Authorization: this.$cookies.get("token"),
                },
              }
            );
            this.orderdetailmodal = false;
            await swal(
              `จัดส่งรายการสั่งซื้อ เลขที่: ${deliveredlist[0].order_no} เรียบร้อย`,
              {
                icon: "success",
                buttons: "ตกลง",
              }
            );
            this.parentgetdata();
          }
        });
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: "กรุณาลองอีกครั้งในภายหลัง",
          icon: "warning",
          buttons: "ตกลง",
          dangerMode: true,
        });
      }
    },
    checkuser() {
      if (this.$cookies.get("status") === "super admin") {
        this.issupadmin = true;
      } else {
        this.issupadmin = false;
      }
    },
    clicktoedit(id) {
      this.$router.push(`/editorder/${id}`);
      this.orderdetailmodal = false;
    },
  },
  computed: {
    orderdetailmodal: sync("orderdetailmodal"),
    currentorderid: sync("currentorderid"),
    orderdetailmode: sync("orderdetailmode"),
  },
  watch: {
    async currentorderid() {
      if (this.currentorderid !== "") {
        await this.getorderdata();
      }
    },
  },
  created() {
    this.checkuser();
    this.getorderdata();
  },
};
</script>
<style>
.headlinestyle {
  font-family: "Kanit";
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-chip {
  font-family: "Kanit";
}
.v-btn {
  font-family: "Kanit";
  font-weight: bold;
}
.v-data-table {
  font-family: "Kanit";
}
.v-list-item {
  font-family: "Kanit";
}
.v-text-field {
  font-family: "Kanit";
}
.v-date-picker {
  font-family: "Kanit";
}
.v-date-picker-title__date > div {
  font-family: kanit;
}
.v-date-picker-header__value button {
  font-family: "Kanit";
}
.v-date-picker-title__year {
  font-family: "Kanit";
}
</style>

<style scoped>
.image {
  position: relative;
  width: 200px;
  max-width: 100%;
}

td {
  max-width: 120px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>
